import { render, staticRenderFns } from "./customer-edit.vue?vue&type=template&id=94bfc7be&scoped=true&"
import script from "./customer-edit.vue?vue&type=script&lang=js&"
export * from "./customer-edit.vue?vue&type=script&lang=js&"
import style0 from "./customer-edit.vue?vue&type=style&index=0&id=94bfc7be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94bfc7be",
  null
  
)

export default component.exports